/**
 * @citeclerk/plan — ESM entry point.
 *
 * 🔴 THIS FILE HOLDS NO DATA. It re-exports limits.cjs, which is the ONE literal. If a number ever
 * appears here, the package has reacquired the exact defect it was built to remove.
 *
 * Named re-exports (rather than `export * from`) because `export *` over a CJS module depends on
 * cjs-module-lexer statically recognising the export shape; a single dynamic assignment in limits.cjs
 * would silently reduce the named exports to nothing but `default`. Destructuring the default is
 * lexer-independent and fails loudly (a TypeError at import time) rather than quietly.
 */
import limits from './limits.cjs';

export const {
  TIERS, TIER_LABEL, CLERK_SLUG_ALIASES, normalizePlan,
  PLAN_LIMITS, METERS, METER_COLUMN, METER_FROM_COLUMN, METER_LABEL,
  // RUN XD — the conditional allotment (free.citations: 10 base, 20 with a verified .edu).
  // `limitFor(plan, meter, ctx)` resolves it; the tables above stay the BASE.
  CONDITIONS, CONDITIONAL_LIMITS, conditionalFor,
  PRIOR_LIMITS, PRIOR_LIMITS_UNTIL, priorFloorFor, baseLimitsFor,
  KIND_TO_METER_COLUMN, meterColumnForKind,
  PRICING, priceCents,
  PACKS, PACK_TTL_MS,
  MATTER_CAP, MATTER_PICKER_SEARCH_THRESHOLD,
  MATTER_LIMITS, matterLimitFor, // RUN JB — the per-MATTER table (clarkEdits, pages); see limits.cjs
  limitsFor, limitFor, remainingFor, tierRank, planChangeKind,
} = limits;

export default limits;
